import React from 'react';

const AboutSectionFour = () => {
  return (
    <section className="about-section-four">
      <div className="auto-container">
        <div className="row">

          {/* Content Column */}
          <div className="content-column col-xl-6 col-lg-12 wow fadeInRight" data-wow-delay="600ms">
            <div className="inner-column">
              <div className="sec-title">
                <span className="sub-title">Visa applicatns</span>
                <h2>Hayal Ülkenize Yolculuğunuzu Planlayalım.</h2>
                <div className="text">
                  There are many variations of passages of available, but that new majority have suffered alteration
                  in simply free text available in the market some form, injected humour, or randomised words.
                </div>
              </div>

              <div className="row">
                <div className="about-block col-lg-6 col-md-6">
                  <div className="inner">
                    <i className="icon flaticon-check-list"></i>
                    <h5 className="title">Legal Immigration <br />Success</h5>
                  </div>
                </div>

                <div className="about-block col-lg-6 col-md-6">
                  <div className="inner">
                    <i className="icon flaticon-documents"></i>
                    <h5 className="title">Required Documents <br />Support</h5>
                  </div>
                </div>
              </div>

              <ul className="list-style-three">
                <li>If you are going to use a passage of you need.</li>
                <li>Lorem ipsum available, but the majority have suffered.</li>
              </ul>

              <a className="theme-btn btn-style-one" href="page-service-details.html">
                <span className="btn-title">Şimdi Keşfet</span>
              </a>
            </div>
          </div>

          {/* Image Column */}
          <div className="image-column col-xl-6 col-lg-12">
            <div className="inner-column wow fadeInLeft">
              <figure className="image overlay-anim wow fadeInUp">
                <img src="/assets/images/resource/about-6.jpg" alt="about" />
              </figure>

              <div className="experience bounce-y">
                <div className="inner">
                  <i className="icon flaticon-rating"></i>
                  <div className="text"><strong>87450</strong> happy customers</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AboutSectionFour;